export const desktopSizes = {
  xl: {
    width: 1056,
    height: 700
  },
  lg: {
    width: 755,
    height: 500
  },
  xs: {
    width: 454,
    height: 301
  }
}

export const desktopMapSizes = {
  xl: {
    width: 1900,
    height: 1380
  },
  lg: {
    width: 1341,
    height: 970
  },
  xs: {
    width: 793,
    height: 570
  }
};

export const mapStyles = {
  xs: {
    container: {
      right: "-150px",
      position: "relative"
    },
    leftSide: {
      width: "86px"
    },
    topBar: {
      width: "11px",
      height: "11px",
      "& > img": {
        width: "6px",
        height: "6px"
      }
    },
    fence: {
      width: "40px",
      height: "40px",
      borderRadius: "25px",
      left: "200px",
      bottom: "18px",
    }
  },
  sm: {
    container: {
      right: "-120px",
      position: "relative"
    },
    leftSide: {
      width: "86px"
    },
    topBar: {
      width: "11px",
      height: "11px",
      "& > img": {
        width: "6px",
        height: "6px"
      }
    },
    fence: {
      width: "45px",
      height: "45px",
      borderRadius: "25px",
      left: "195px",
      bottom: "15px",
    }
  },
  md: {
    container: {
      right: "-190px",
      position: "relative"
    },
    leftSide: {
      width: "143px"
    },
    topBar: {
      width: "27px",
      height: "27px",
      "& > img": {
        width: "13px",
        height: "13px"
      }
    },
    fence: {
      width: "80px",
      height: "80px",
      borderRadius: "40px",
      left: "330px",
      bottom: "5px",
    }
  },
  lg: {
    container: {
      right: "-160px",
      position: "absolute"
    },
    leftSide: {
      width: "143px"
    },
    topBar: {
      width: "27px",
      height: "27px",
      "& > img": {
        width: "13px",
        height: "13px"
      }
    },
    fence: {
      width: "80px",
      height: "80px",
      borderRadius: "40px",
      left: "330px",
      bottom: "1px",
    }
  },
  xl: {
    container: {
      right: "-220px",
      position: "absolute"
    },
    leftSide: {
      width: "200px"
    },
    topBar: {
      width: "27px",
      height: "27px",
      "& > img": {
        width: "13px",
        height: "13px"
      }
    },
    fence: {
      width: "110px",
      height: "110px",
      borderRadius: "55px",
      left: "465px",
      bottom: "2px",
    }
  }
}